import React, { useState } from "react";
import { Col } from "react-bootstrap";
import styled from "styled-components";

import Layout from "../components/layout/layout";
import { Black } from "../components/theme/colors";
import InboxContent from "./InboxContent";

import { useAuth } from "../services/AuthContext";
import mixpanelService from "../services/MixpanelService";
import postHogService from "../services/PostHogService";

const ContentWrapper = styled.div`
  width: 100%;
  min-height: 100%;
`;

const Inbox = () => {
  const { currentUserState } = useAuth();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Track page view on mount
  React.useEffect(() => {
    const inboxViewProps = {
      page: "Inbox",
      user_id: currentUserState?.uid || "anonymous",
      timestamp: new Date().toISOString(),
    };
    mixpanelService.track("Inbox Page Viewed", inboxViewProps);
    postHogService.track("Inbox Page Viewed", inboxViewProps);
  }, [currentUserState]);

  // Refresh inbox when page becomes visible
  React.useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        setRefreshTrigger((prev) => prev + 1);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <Layout $background={Black}>
      <Col
        lg={{ offset: 4, span: 4 }}
        md={{ offset: 3, span: 6 }}
        sm={{ offset: 2, span: 8 }}
        xs={{ span: 12 }}
        className="text-align-center"
      >
        <ContentWrapper>
          <InboxContent refreshTrigger={refreshTrigger} />
        </ContentWrapper>
      </Col>
    </Layout>
  );
};

export default Inbox;
